export const SHOW_IMPORT_MODAL = 'SHOW_IMPORT_MODAL';
export const HIDE_IMPORT_MODAL = 'HIDE_IMPORT_MODAL';

export const IMPORT_LIST_CUSTOMERS = "IMPORT_LIST_CUSTOMERS";
export const IMPORT_LIST_IMPORTERS = "IMPORT_LIST_IMPORTERS";